module.exports = __webpack_public_path__ + "img/safety-careers.c988659b.jpg";